
import { useTranslation } from 'react-i18next';
import { SubscriptionManagement } from '@/components/subscriptions/subscription-management';
import { PageHeader } from '@/components/shared/page-header';

export default function BillingPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <PageHeader title={t('billing.title')} description={t('billing.description')} />

      <SubscriptionManagement />
    </div>
  );
}
